import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 47,
  label: "申请人合作关系分析",
  chart: charts.matrixPie2D,
  definition: {
    queryBean: "applicantCooperationReport",
    rowDims: [{ name: "applicantNewName", label: "申请人1", table: "patent_applicant", limit: 10 }],
    colDims: [{ name: "applicantNewName", label: "申请人2", table: "patent_applicant", limit: 10 }],
    measures: [{ name: "count", label: "合作申请量", sortBy: "DESC" }],
    showNoDataDims: false,
  },
  chartOption: {
    chartType: ChartType.PIE,
    title: "申请人合作关系分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: false,
    hideLabel: false,
    hideLegend: false,
    hideToolbox: false,
  },
};
